import React from 'react';
import Container from '@src/components/Shared/Container';
import NextImage from '@src/components/Shared/NextImage';
import SectionHeader from '@src/components/Shared/SectionHeader';
import { ImageTextPrimaryPropTypes } from './ImageTextPrimary.types';
import NextLink from '@src/components/Shared/NextLink';

const ImageTextPrimary: React.FC<ImageTextPrimaryPropTypes> = ({
  className,
  pretitle,
  title,
  imgURL,
  imgLink = '',
  imgURLSecondary,
  imgURLSecondaryClassName,
  imgAlt = '',
  imgAltSecondary = '',
  childrenElements,
  reversed = false,
  imgChildElements = null,
  id,
  imgFirstClassName = '',
  imgSecondClassName = '',
  textContainerClassName = '',
  textContentBackgroundClassName = '',
  sectionHeaderClassName = '',
}) => {
  return (
    <Container id={id} className={`flex flex-col lg:flex-row lg:items-center ${className}`}>
      {/* Mobile Image (always first) */}
      {imgLink ? (
        <NextLink href={imgLink} className='mb-[2.4rem] lg:hidden' title={imgAlt}>
          <NextImage
            className={`${imgFirstClassName}`}
            src={imgURL}
            alt={imgAlt}
            aspectRatio={16 / 9}
            width={100}
          >
            {imgChildElements}
          </NextImage>
        </NextLink>
      ) : (
        <NextImage
          className={`mb-[2.4rem] lg:hidden ${imgFirstClassName}`}
          src={imgURL}
          alt={imgAlt}
          aspectRatio={16 / 9}
          width={100}
        >
          {imgChildElements}
        </NextImage>
      )}

      {/* Desktop Image */}
      <div
        className={`mr-[-10rem] hidden lg:block lg:w-[calc(50%+10rem)] ${reversed ? 'ml-[-10rem] lg:order-2' : 'mr-[-10rem] lg:order-1'}`}
      >
        {imgLink ? (
          <NextLink href={imgLink} title={imgAlt}>
            <NextImage
              className={imgSecondClassName}
              src={imgURL}
              alt={imgAlt}
              aspectRatio={16 / 9}
              width={100}
            >
              {imgChildElements}
            </NextImage>
          </NextLink>
        ) : (
          <NextImage
            className={imgSecondClassName}
            src={imgURL}
            alt={imgAlt}
            aspectRatio={16 / 9}
            width={100}
          >
            {imgChildElements}
          </NextImage>
        )}
      </div>

      {/* Secondary Image (if provided) */}
      {imgURLSecondary && (
        <NextImage
          className={`relative z-10 hidden lg:block ${imgURLSecondaryClassName}`}
          src={imgURLSecondary}
          alt={imgAltSecondary}
          aspectRatio={16 / 9}
          width={100}
        />
      )}

      {/* Text Content */}
      <div
        className={`lg:relative lg:z-20 lg:w-[50%] ${reversed ? 'lg:order-1' : 'lg:order-2'} ${textContainerClassName}`}
      >
        <div
          className={`hidden min-h-full bg-background-secondary shadow-[0px_0px_25px_5px_rgba(0,0,0,0.05)] lg:absolute lg:top-[50%] lg:z-[-15] lg:block lg:h-[calc(100%-10rem)] lg:w-full lg:translate-y-[-50%] lg:transform ${textContentBackgroundClassName}`}
        />

        <SectionHeader
          className={`lg:relative lg:z-5 lg:px-[6rem] lg:py-[10rem] ${sectionHeaderClassName}`}
          pretitle={pretitle}
          preTitleClassName='mb-[1.6rem]'
          title={title}
          titleClassName='text-[2.8rem] leading-[3.2rem] mb-[1.8rem] lg:mb-[3.2rem] lg:text-[4.8rem] lg:leading-[5rem] lg:tracking-[-0.096rem]'
          childrenClassName='relative'
          align='left'
        >
          {childrenElements}
        </SectionHeader>
      </div>
    </Container>
  );
};

export default ImageTextPrimary;
